import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import BackBG from "../../assets/images/icons/box.svg";
import Scores from "./scores/Scores";
import Progression from "./progression/Progression";
import Milestones from "./milestones/Milestones";
import ScoreIcon from "../../assets/images/icons/performance/score.svg";
import ActiveScoreIcon from "../../assets/images/icons/performance/score-active.svg";
import ProgressionIcon from "../../assets/images/icons/performance/progression.svg";
import ActiveProgressionIcon from "../../assets/images/icons/performance/progression-active.svg";
import MilestoneIcon from "../../assets/images/icons/performance/milestone.svg";
import ActiveMilestoneIcon from "../../assets/images/icons/performance/milestone-active.svg";
import ButtonBG from "../../assets/images/icons/button-bg.png";
import ActiveButtonBG from "../../assets/images/icons/active-bg.png";

const Tabs = [
  {
    label: "Scores",
    content: <Scores />,
    imgIcons: ScoreIcon,
    iconsActive: ActiveScoreIcon,
  },
  {
    label: "Progression",
    content: <Progression />,
    imgIcons: ProgressionIcon,
    iconsActive: ActiveProgressionIcon,
  },
  {
    label: "Milestones",
    content: <Milestones />,
    imgIcons: MilestoneIcon,
    iconsActive: ActiveMilestoneIcon,
  },
];

const Performances = () => {
  const planName = useSelector((state) =>
    state.user.user?.planName?.toLowerCase()
  );

  const filteredTabs =
    planName === "player"
      ? Tabs.filter((tab) => tab.label !== "Progression")
      : Tabs;

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (activeTab >= filteredTabs.length) {
      setActiveTab(0);
    }
  }, [activeTab, filteredTabs.length]);

  return (
    <>
      <div className="mb-5 flex max-lg:flex-col gap-4 items-center justify-between">
        <Link to="/" className="relative cursor-pointer">
          <div className="max-h-20">
            <img
              src={BackBG}
              alt="Back Background"
              className="w-full h-full max-h-10"
            />
          </div>
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-base">
            Back
          </span>
        </Link>
        <div className="flex max-sm:flex-col gap-4 w-full justify-center">
          {filteredTabs?.map((tab, index) => (
            <React.Fragment key={index}>
              <div
                onClick={() => setActiveTab(index)}
                className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
              >
                <div className="relative z-20">
                  <img
                    src={activeTab === index ? tab.iconsActive : tab.imgIcons}
                    alt="Performance-Icon"
                  />
                </div>
                <div className="relative md:-left-[60px] -left-[28px] z-10">
                  <img
                    src={activeTab === index ? ActiveButtonBG : ButtonBG}
                    alt="Performance-Icon"
                  />
                  <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold ml-3 text-lg">
                    {tab.label}
                  </span>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="w-full">
        <div className="p-4">{filteredTabs[activeTab]?.content}</div>
      </div>
      {/* <div className="grid grid-cols-1 tab:grid-cols-3 items-start gap-5 mt-10 text-black">
        <Link
          to="/performance/score"
          className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
        >
          <div className="relative z-20">
            <img src={Scores} alt="Performance-Icon" />
          </div>
          <div className="relative md:-left-[31px] -left-[28px] z-10">
            <img src={ButtonBG} alt="Performance-Icon" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-lg">
              Score
            </span>
          </div>
        </Link>
        <Link
          to="/performance/progression"
          className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
        >
          <div className="relative z-20">
            <img src={Progressions} alt="Performance-Icon" />
          </div>
          <div className="relative md:-left-[31px] -left-[28px] z-10">
            <img src={ButtonBG} alt="Performance-Icon" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-lg whitespace-nowrap">
              Progression
            </span>
          </div>
        </Link>
        <Link
          to="/performance/milestone"
          className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
        >
          <div className="relative z-20">
            <img src={Milestones} alt="Performance-Icon" />
          </div>
          <div className="relative md:-left-[31px] -left-[28px] z-10">
            <img src={ButtonBG} alt="Performance-Icon" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-lg">
              Milestone
            </span>
          </div>
        </Link>
      </div> */}
    </>
  );
};

export default Performances;
